import { createAction } from '@reduxjs/toolkit'
import { AdminLoginForm, AuthInfo } from 'src/types/common'

export const adminLogin = createAction<AdminLoginForm>('ADMIN_LOGIN')
export const adminLoginSuccess = createAction<AuthInfo>('ADMIN_LOGIN_SUCCESS')
export const adminLoginFailure = createAction<void>('ADMIN_LOGIN_FAILURE')
